<template>
  <div>
    <Modal v-model="showModal" :title="$t('product.info.upload_file')" footer-hide>
      <Form ref="fileForm" :model="fileUploadData" :rules="ruleValidate" :label-width="120">
        <Row :gutter="32">
          <Col :span="22" v-show="!fileId">
            <FormItem :label="$t('product.info.file_type')" prop="collection" required>
              <Select v-model="fileUploadData.collection" filterable allow-create
                @on-create="handleCreateFileCollecton"
                placeholder="Select or enter to create new file type">
                <Option v-for="collection in productFileCollections"
                        :value="collection.key"
                        :key="collection.key">{{ collection.value }}</Option>
              </Select>
              <div class="desc font-size-80 text-no-break">
                {{ getDescriptionText(fileUploadData.collection) }}
              </div>
            </FormItem>
          </Col>
          <Col :span="22">
            <FormItem :label="$t('product.info.file_description')" prop="description" required>
              <Input type="textarea"
                     v-model="fileUploadData.description"
                     placeholder="[version]-[part]-[filename]-[date]">
              </Input>
              <div class="desc font-size-80 text-no-break">
                A well formatted description can help you identify the file purpose easily.
              </div>
            </FormItem>
          </Col>
          <Col :span="22">
          <FormItem :label="$t('product.info.upload_file')">
              <FileManagedSimpleUploader
                @on-success="handleFileUploaded"
                :fileId="fileId"
                :data="fileUploadData"
                :disableUpload="disableUpload"
                :show-upload-list="false">
              </FileManagedSimpleUploader>
              <Alert closable type="warning" v-show="disableUpload" style="margin-top:5px;">
                {{ $t('product.info.file_type_description_attributes_are_required') }}</Alert>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
    <FileManagedSimpleAttachmentsTable ref="fileManagedAttachments"
                                      style="margin-bottom:10px;"
                                      :attachable="{ type: 'product', id: productId }"
                                      :collection-map="productFileCollections"
                                      @replaceFile="handleReplaceFile">
    </FileManagedSimpleAttachmentsTable>
    <div>
      <Button type="primary" @click="handleUploadNewFile">{{ $t('product.info.upload_file') }}</Button>
    </div>
  </div>
</template>

<script>
import {
  FileManagedSimpleUploader,
  FileManagedSimpleAttachmentsTable
} from '@/components/file'
import { attachFile } from '@/api/file'
export default {
  name: 'ProductAttachmentsPlugin',
  components: {
    attachFile,
    FileManagedSimpleUploader,
    FileManagedSimpleAttachmentsTable
  },
  props: {
    productId: {
      required: true
    }
  },
  data() {
    return {
      disableUpload: true,
      fileId: null,
      showModal: false,
      ruleValidate: {

      },
      fileUploadData: {
        collection: null,
        description: null
      },
      productFileCollections: [
        {
          key: 'product_images',
          value: 'Product Images',
          desc: 'Images of the product.'
        },
        {
          key: 'bom',
          value: 'BOM',
          desc: 'BOMs of the product, such as, EBOM received from customer.'
        },
        {
          key: 'ee',
          value: 'EE',
          desc: 'EE related files, such as, PCB, SMT and etc.'
        },
        {
          key: 'me',
          value: 'ME',
          desc: 'ME related files, such as, modling, structure, design and etc..'
        },
        {
          key: 'instructions',
          value: 'Instructions',
          desc: 'Any instruction documents, such as assembly, testing instructions.'
        },
        {
          key: 'logistcis',
          value: 'Logistics',
          desc: 'Any logistic related documents.'
        },
        {
          key: 'project',
          value: 'Project',
          desc: 'Project management documents, such as, schedules, customer agreements.'
        },
        {
          key: 'tests',
          value: 'Tests',
          desc: 'For example, test results.'
        },
        {
          key: 'misc',
          value: 'Misc',
          desc: 'Any of the rest will be in this misc category.'
        }
      ]
    }
  },
  watch: {
    fileUploadData: {
      handler: function () {
        this.checkDisableUpload()
      },
      deep: true
    }
  },
  methods: {
    checkDisableUpload () {
      this.disableUpload = !(this.fileId || this.fileUploadData.collection) || !this.fileUploadData.description
    },
    handleCreateFileCollecton (collection) {
      this.productFileCollections.push(collection)
    },
    handleFileUploaded (fileManaged, file) {
      attachFile('product', this.productId, fileManaged.id).then(resp => {
        this.$refs.fileManagedAttachments.update()
        this.showModal = false
      })
    },
    handleReplaceFile(fileId) {
      this.fileId = fileId
      this.fileUploadData.description = null
      this.showModal = true
    },
    handleUploadNewFile () {
      this.fileId = null
      this.fileUploadData.description = null
      this.showModal = true
    },
    getDescriptionText (collectName) {
      if (collectName) {
        let selected = _.find(this.productFileCollections, { key: collectName })
        return selected.desc
      }
      return ''
    }
  }
}
</script>

<style lang="less" scoped>

</style>
